module.exports = __webpack_public_path__ + "static/20180911_202739_optimized-8e6cc78997c1dffad5a428bb3efc7a96.jpg";